import { render, staticRenderFns } from "./TimeBox.vue?vue&type=template&id=4b1a7b64&scoped=true&"
import script from "./TimeBox.vue?vue&type=script&lang=js&"
export * from "./TimeBox.vue?vue&type=script&lang=js&"
import style0 from "./TimeBox.vue?vue&type=style&index=0&id=4b1a7b64&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b1a7b64",
  null
  
)

export default component.exports